(function () {
'use strict';

angular
  .module('hyresgastApp')
  .controller('NegotiationTableNegotiatorFinishedListCtrl', NegotiationTableNegotiatorFinishedListCtrl);

function NegotiationTableNegotiatorFinishedListCtrl(
  $scope, $location, $routeParams, $filter,
  FeatureConfiguration, CombinedNegotiationStates, NegotiationStates, NegotiationTypes, SubPage, User
) {
  var vm = this;
  vm.FeatureConfiguration = FeatureConfiguration;

  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.columns = [
    { title: 'Id', column: 'caseNumber' },
    { title: 'Namn', column: 'negotiationName' },
    {
      title: 'Förhandlingstyp',
      template: 'slot1',
      column: 'type',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.negotiationTypeChoices,
        multi: true,
      },
    },
    { title: 'Hyresändring', column: 'createdAt' },
    {
      title: 'Status',
      template: 'status',
      column: 'combinedState',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.statusChoices,
        multi: true,
      },
    },
    { title: 'Senast ändrad', column: 'rentEffectiveFrom' }
  ];
  if (vm.FeatureConfiguration.ENABLE_MEETINGS) {
    vm.listColumns.splice(4, 0, { title: 'Nästa möte', column: 'updatedAt' });
  }

  vm.gotoNegotiation = function (negotiation) {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }

  vm.getData = function (params) {
    // eslint-disable-next-line no-undef, no-unused-vars
    return new Promise((resolve, reject) => {
      User.queryNegotiationsWithMe(Object.assign({
        partnerId: $routeParams.partnerId,
        'filters[counterpartOrganizationId]': $routeParams.organizationId,
        'filters[state]': [NegotiationStates.FINISHED],
      }, params)).$promise.then(function(data) {
        //TODO: replace with column.type = 'date'
        data.rows.forEach(x => {
          x.rentEffectiveFrom = $filter('date')(x.rentEffectiveFrom, 'yyyy-MM-dd');
          x.createdAt = $filter('date')(x.createdAt, 'yyyy-MM-dd');
        });
        resolve(data);
      });
    });
  }

  vm.getContextInfo = row => ({
    title: `Förhandling ${row.caseNumber}`,
    link: '/negotiations/'+row.id,
  });
}

})();